export default __webpack_public_path__ + "static/media/calendar-icon.ba7dc52e.svg";